import { useMemo } from "react";
import { Checkbox } from "@/components/ui/checkbox";
import { CA_DESIGNATIONS, US_DESIGNATIONS, ALL_DESIGNATIONS } from "@/constants/professionalDesignations";

interface AdvisorCredentialsSelectProps {
  country?: string;
  value: string[];
  onChange: (next: string[]) => void;
}

function normalizeCountry(c?: string) {
  if (!c) return "";
  const v = c.toLowerCase();
  if (v === "ca" || v.includes("canada")) return "CA";
  if (v === "us" || v.includes("united states") || v.includes("usa")) return "US";
  return "";
}

export function AdvisorCredentialsSelect({ country, value, onChange }: AdvisorCredentialsSelectProps) {
  const region = normalizeCountry(country);
  const options = useMemo(() => {
    let list: readonly string[];
    if (region === "CA") list = CA_DESIGNATIONS as readonly string[];
    else if (region === "US") list = US_DESIGNATIONS as readonly string[];
    else list = ALL_DESIGNATIONS as readonly string[];

    const other = "Other professional designation";
    const withoutOther = list.filter((x) => x !== other);
    return [...withoutOther, other] as readonly string[];
  }, [region]);

  const toggle = (opt: string) => {
    if (value.includes(opt)) onChange(value.filter(v => v !== opt));
    else onChange([...value, opt]);
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
      {options.map((opt) => (
        <label key={opt} className="flex items-center gap-2 text-sm">
          <Checkbox checked={value.includes(opt)} onCheckedChange={() => toggle(opt)} />
          <span>{opt}</span>
        </label>
      ))}
    </div>
  );
}
